import { normalizeUrlPath } from "Libs/utils";

import { urlKeys } from "./urlKeys";

import type { UrlKeyOptions, UrlKeysType, GetUrlProps } from "./types";

const doNotEncodeParams = ["queryParams"];

const getPath = (
  pathObject: UrlKeysType[string],
  props: GetUrlProps["props"],
  key: UrlKeyOptions,
  noEncode: GetUrlProps["noEncode"]
) => {
  if (!pathObject?.params) return pathObject?.path;

  let pathCopy = pathObject?.path;

  pathObject.params.forEach(param => {
    if (props?.[param] !== "" && !props?.[param]) {
      throw new Error(`${param} is required for the key of ${key}`);
    } else {
      const skipEncode =
        (noEncode && noEncode?.includes(param)) ||
        doNotEncodeParams.includes(param);

      const replacementParam = skipEncode
        ? props[param]
        : encodeURIComponent(props[param]);

      pathCopy = pathCopy.replace(`:${param}`, replacementParam);
    }
  });

  return pathCopy;
};

export const getUrl = ({ key, props = {}, noEncode = false }: GetUrlProps) => {
  const url: string[] = [];
  const paths = key.split(".");
  let obj = urlKeys;
  for (const elt of paths) {
    const currentPath = obj[elt];
    const result = getPath(currentPath, props, key, noEncode);

    url.push(result);
    if (currentPath?.subpath) {
      obj = currentPath.subpath;
    }
  }

  const slash = /^(auth|accountUrl)/.test(key) ? "" : "/";

  return normalizeUrlPath(`${slash}${url.join("/")}`);
};
